<template>
    <div class="pt-8">
        <SalesCommissionTrackerFilterForm 
            :filter="filter" 
            @get-seller-list="getSalesCommissionsBySellerAndDateRangeList()" 
            @clear-filter-form="clearFilterForm()" 
        />
        <SalesComissionTrackerTable 
            :sellerList="sellerList" 
            :paginator="paginator" 
            :pageSize="pageSize" 
            @get-seller-list="getSalesCommissionsBySellerAndDateRangeList()" 
            @change-page="changePage($event)" 
            @open-seller-order-list="getOrdersUserByDateRangeList($event)"
            
        />
        <SalesCommissionTrackerOrdersUserTable v-if="showSalesCommissionordersTable"
            :sellerInfo="sellerInfo"
            :sellerOrders="sellerOrders"
            :paginator="sellerOrdersPaginator" 
            :pageSize="pageSize"
            :filterInfo="filter"
            @get-seller-orders-list="getOrdersUserByDateRangeList($event)"
            @change-page="changeOrdersPage($event, sellerInfo)"
            @clear-orders-user-range-list="clearOrdersUserRangeList()"
        />
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import SalesCommissionTrackerFilterForm from '../components/SalesCommissionTrackerFilterForm.vue'
import SalesComissionTrackerTable from '../components/SalesCommissionTrackerTable.vue'
import SalesCommissionTrackerOrdersUserTable from '../components/SalesCommissionTrackerOrdersUserTable.vue'
export default {
    computed: {
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            sellerList: [],
            filter: {
                dateFrom: '',
                dateTo: new Date().toISOString().substr(0, 10),
            },
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            modalReset: false,
            userReset: {},
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            sellerOrders: [],
            sellerInfo: {},
            sellerOrdersPaginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            showSalesCommissionordersTable: false,
        }
    },
    components: {
        SalesCommissionTrackerFilterForm,
        SalesComissionTrackerTable,
        SalesCommissionTrackerOrdersUserTable
    },
    created(){
        this.getSalesCommissionsBySellerAndDateRangeList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getSalesCommissionsBySellerAndDateRangeList(){
            //close and reset data of the orders user list table;
            this.clearOrdersUserRangeList();
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                dateFrom:     this.filter.dateFrom,
                dateTo:       this.filter.dateTo,
            }
            this.sellerList = [];
            this.setLoading(true)
            await this.$conectar.post('/sales-commission-tracker/sales-commissions/by-seller-and-date-range', this.pageOptions)
            .then(response =>{
                this.sellerList = response.data.sellerList;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getOrdersUserByDateRangeList(sellerInfo){
            this.showSalesCommissionordersTable = false;
            this.pageOptions = {
                seller_id: sellerInfo.id,
                pageNumber: this.sellerOrdersPaginator.page, 
                pageSize:   this.sellerOrdersPaginator.pageSize,
                dateFrom:     this.filter.dateFrom,
                dateTo:       this.filter.dateTo,
            }
            this.sellerOrders = [];
            this.sellerInfo = {}
            this.setLoading(true)
            await this.$conectar.post('/sales-commission-tracker/sales-commissions/orders-user-date-range', this.pageOptions)
            .then(response =>{
                this.sellerOrders = response.data.sellerOrders;
                this.sellerInfo = response.data.sellerInfo;
                this.sellerOrdersPaginator.totalPage = response.data.totalPages;
                this.showSalesCommissionordersTable = true;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getSalesCommissionsBySellerAndDateRangeList();
        },
        clearFilterForm(){
            this.filter.dateFrom = "";
            this.filter.dateTo = new Date().toISOString().substr(0, 10);
            this.paginator.pageSize = 10;
        },
        clearOrdersUserRangeList(){
            this.showSalesCommissionordersTable = false;
            this.sellerOrders = [];
            this.sellerInfo = {};
            this.sellerOrdersPaginator = {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            };
        },
        changeOrdersPage(page, sellerInfo){
            this.sellerOrdersPaginator.page = page;
            this.getOrdersUserByDateRangeList(sellerInfo);
        },
    }
}
</script>